// extracted by mini-css-extract-plugin
module.exports = {"title":"errorModal_title__N4wEd","text":"errorModal_text__g8Q4o","contact":"errorModal_contact__vIfII","buttonContainer":"errorModal_buttonContainer__W3p50"};